import { render } from "./SidebarLevel2.vue?vue&type=template&id=5f9ed164&ts=true"
import script from "./SidebarLevel2.vue?vue&type=script&lang=ts"
export * from "./SidebarLevel2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__